// The site header: on every page, 54px tall, surface behind it (CLAUDE.md:
// Design tokens — Site header). It stays visible while a modal is open, dimmed
// by the overlay rather than covered.
//
// **The brand is the way home**, from every page: there is no "All games" link
// anywhere else. The three icon buttons open the archive, the stats and How to
// play, in that order. The archive icon shows from day one — its tabs are gated separately,
// not the icon. Nothing else: the header is for getting somewhere, and About is
// a footer link. **It is the same header on every format.**
//
// **On a phone held sideways the game's own title — the game and its number —
// joins this bar** through the slot between the brand and the icons, so it costs
// no height of its own (GameHeader.tsx). The
// test and development badges live here too: they float over the page upright,
// and sideways, where the page has no room to float anything over, they take
// their place in the bar.
import { Link } from 'react-router-dom';
import { PreviewBadge } from '../dev/PreviewBadge.tsx';
import { TestBadge } from './TestBadge.tsx';
import './SiteHeader.css';

interface Props {
  onOpenHelp?: () => void;
  onOpenArchive?: () => void;
  onOpenStats?: () => void;
}

export function SiteHeader({ onOpenHelp, onOpenArchive, onOpenStats }: Props) {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link to="/" className="site-brand">Cinemore</Link>
        <div className="site-header-slot" id="site-header-slot" />
        <TestBadge />
        <PreviewBadge />
        <div className="site-header-actions">
          <button type="button" className="icon-button" aria-label="Archive" title="Archive"
                  onClick={onOpenArchive}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
              <rect x="3" y="5" width="18" height="16" rx="2" />
              <path d="M3 10h18" /><path d="M8 3v4" /><path d="M16 3v4" />
            </svg>
          </button>
          <button type="button" className="icon-button" aria-label="Your stats" title="Your stats"
                  onClick={onOpenStats}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
              <path d="M5 20V11" /><path d="M12 20V4" /><path d="M19 20v-6" />
            </svg>
          </button>
          <button type="button" className="icon-button" aria-label="How to play" title="How to play"
                  onClick={onOpenHelp}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 9a3 3 0 1 1 4.2 2.75c-.75.33-1.2 1.07-1.2 1.89V14.5" />
              <path d="M12 18.25v.01" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
